export default "__VITE_ASSET__Dv2EuDz6__"